import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AddSessionComponent } from "./add-session/add-session.component";
import { AuthGuard } from './Auth/auth.guard';
import { SearchSessionComponent } from "./search-session/search-session.component";
import { SubscriptionComponent } from "./subscription/subscription/subscription.component";
import { SearchSubscriptionComponent } from "./search-subscription/search-subscription.component";
import { AdditionalQuestionsComponent } from "./additional-questions/additional-questions.component";
import { DatacleanUpComponent } from "./dataclean-up/dataclean-up.component";
import { ManageMailboxComponent } from "./manage-mailbox/manage-mailbox.component";
import { ManageEmailTemplateComponent } from "./manage-email-template/manage-email-template.component";
import { SearchEmailTemplateComponent } from "./search-email-template/search-email-template.component";
import { SessionTimeoutComponent } from "./session-timeout/session-timeout.component";
import { CreateOrganizationComponent } from "./organization/create-organization/create-organization.component";
import { SearchOrganizationComponent } from "./organization/search-organization/search-organization.component";
import { SecurityComponent } from "./security/security.component";
import { FacilitatorSearchComponent } from './facilitator-search/facilitator-search.component';
import { AssessmentComponent } from './assessment/assessment.component';
import { UnauthorisedComponent } from "./unauthorised/unauthorised.component";
import { ResourcesComponent } from './resources/resources.component';
import { TeamSnapshotComponent } from "./team-snapshot/team-snapshot.component";
import { MsalGuard } from "@azure/msal-angular";
import { UserUnauthorizedComponent } from "./user-unauthorized/user-unauthorized.component";
import { CookieNoticeComponent } from "./cookie-notice/cookie-notice.component";

const routes: Routes = [
  {
    path: "",
    component: SearchSessionComponent,
    canActivate: [MsalGuard],
    title: "Search Session",
    data: { title: "Search Session" },
  },
  {
    path: "addSession",
    component: AddSessionComponent,
    canActivate: [MsalGuard],
    title: "Add Session",
    data: { title: "Add Session" },
  },
  {
    path: "editSession",
    component: AddSessionComponent,
    title: "Edit Session",
    data: { title: "Edit Session" },
  },
  {
    path: "searchSession",
    component: SearchSessionComponent,
    title: "Search Session" ,
    data: { title: "Search Session" },
  },
  {
    path: "editSession/:id",
    component: AddSessionComponent,
    title: "Edit Session",
    data: { title: "Edit Session" },
  },
  {
    path: "assessment",
    component: AssessmentComponent,
    title: "Assessment Search",
    data: { title: "Assessment Search" },
    canActivate: [MsalGuard]
  },
  {
    path: "team-snapshot",
    component: TeamSnapshotComponent,
    title: "Team Snapshot",
    data: { title: "Team Snapshot" }
  },
  {
    path: "security",
    component: SecurityComponent,
    canActivate: [MsalGuard],
    title: "Security",
    data: { title: "Security" },
  },
  {
    path: "facilitatorSearch",
    component: FacilitatorSearchComponent,
    title: "Facilitator Session",
    canActivate: [MsalGuard],
    data: { title: "Facilitator Session" },
  },
  {
    path: "resources",
    component: ResourcesComponent,
    title: "Resources",
    data: { title: "Resources" },
  },
  {
    path: "addSubscription",
    component: SubscriptionComponent,
    //canActivate: [AuthGuard],
    title: "Add Subscription",
    data: { title: "Add Subscription" },
  },
  {
    path: "searchSubscription",
    component: SearchSubscriptionComponent,
    //canActivate: [AuthGuard],
    title: "Search Subscription",
    data: { title: "Search Subscription" },
  },
  {
    path: "editSubscription",
    component: SubscriptionComponent,
    //canActivate: [AuthGuard], //for Add/edit subscription module comment canActivate
    title: "Edit Subscription",
    data: { title: "Edit Subscription" },
  },
  {
    path: "additionalQuestionsReport",
    component: AdditionalQuestionsComponent,
    canActivate: [MsalGuard],
    title: "Additional Questions Report",
    data: { title: "Additional Questions Report" },
  },

  {
    path: "dataCleanup",
    component: DatacleanUpComponent,
    canActivate: [AuthGuard],
    title: "Data Clean Up",
    data: { title: "Data Clean Up" },
  },
  {
    path: "manageMailBox",
    component: ManageMailboxComponent,
    canActivate: [AuthGuard],
    title: "Manage Mail Box",
    data: { title: "Manage Mail Box" },
  },
  {
    path: "sessionTimeout",
    component: SessionTimeoutComponent,
    title: "SessionTimeout",
    data: { title: "SessionTimeout" }
  },
  {
    path: "manageEmailTemplate",
    component: ManageEmailTemplateComponent,
    canActivate: [AuthGuard],
    title: "Manage Email Template",
    data: { title: "Manage Email Template" }
  },
  {
    path: "searchEmailTemplate",
    component: SearchEmailTemplateComponent,
    canActivate: [AuthGuard],
    title: "Search Email Template",
    data: { title: "Search Email Template" }
  },
  {
    path: "createClient",
    component: CreateOrganizationComponent,
    canActivate: [AuthGuard],
    title: "Create Client",
    data: { title: "Create Client" }
  },
  {
    path: "unauthorised",
    component: UnauthorisedComponent,
    title: "Unauthorised " ,
    data: { title: "Unauthorised " },
  },
  {
    path: "searchOrganization",
    component: SearchOrganizationComponent,
    canActivate: [MsalGuard],
    title: "Search Organization",
    data: { title: "Search Organization" }
  },
  {
    path: "Admin/Unauthorized",
    component: UserUnauthorizedComponent, 
    data: { title: "Forbidden Access" }
  },
  { 
    path:'cookie-notice',
    component: CookieNoticeComponent
  },
  { path: 'admin', redirectTo: '', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes,
    { useHash: true,
      onSameUrlNavigation: 'reload' })],
      exports: [RouterModule],
})
export class AppRoutingModule { }
